import type { ConsentEventPayload } from "@cmp/shared";

/**
 * Sends as `text/plain` (a CORS-safelisted content type) rather than
 * `application/json` to skip the preflight OPTIONS roundtrip entirely.
 * The body is still JSON; the server parses it with `c.req.json()` which
 * doesn't care about the Content-Type header.
 */
export function logEvent(apiBase: string, payload: ConsentEventPayload): void {
  const url = `${apiBase}/consent/events`;
  const body = JSON.stringify(payload);
  try {
    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      const blob = new Blob([body], { type: "text/plain" });
      if (navigator.sendBeacon(url, blob)) return;
    }
  } catch {
    /* fall through to fetch */
  }
  void fetch(url, {
    method: "POST",
    body,
    headers: { "content-type": "text/plain" },
    credentials: "omit",
    mode: "cors",
    keepalive: true,
  }).catch(() => {
    /* swallow — logging must never break the page */
  });
}
